import DashboardIcon from "./../assets/images/dashboard.png";
import DocumentIcon from "./../assets/images/documentIcon.png";
import HistoryIcon from "./../assets/images/historyIcon.png";
import PaymentIcon from "./../assets/images/paymentIcon.png";
import DisbursementIcon from "./../assets/images/disbursementIcon.png";
import HelpOutlineIcon from "./../assets/images/help.png";

export const ROUTES = {
  Base: {
    index: "/",
    indexReplacePath: "dashboard",
    notMatch: "*",
    notFound: "/page-not-found",
    sessionTimeout: "/session-timeout",
  },
  ApplyNow: {
    index: "/apply-now",
    locationPath: "/apply-now",
  },
  HelpCenter: {
    index: "/help-center",
    locationPath: "/help-center",
  },
  ApplyLoan: {
      index: "apply-loan",
      locationPath: "/apply-loan",
  },
  ConsentAuthorization: {
      index: "consent-authorization",
      locationPath: "/consent-authorization",
  },
  // login
  Login: {
    index: "/login",
    otp: {
      path: "otp",
      locationPath: "/login/otp",
    },
    register: {
      path: "register",
      locationPath: "/login/register",
    },
    thankYouPage: {
      path: "thank-you",
      locationPath: "/login/thankYouPage",
    },
    selectProfile: {
      path: "select-profile",
      locationPath: "/login/select-profile",
    },
    setPassword: {
      path: "set-password",
      locationPath: "/login/set-password",
    },
    enterPassword: {
      path: "enter-password",
      locationPath: "/login/enter-password",
    },
    forgotPassword: {
      path: "forgot-password",
      locationPath: "/login/forgot-password",
    },
    passwordCreated: {
      path: "password-created",
      locationPath: "/login/password-created",
    },
    loginType: {
      path: "login-type",
      locationPath: "/login/login-type",
    },
  },
  // dashboard
  Application: {
    index: "/application",
    summary: {
      path: "summary",
      locationPath: "/application/summary",
    },
    loanSummary: {
      path: "loan-summary",
      locationPath: "/application/loan-summary",
    },
    existingApplication: {
      path: "existing-application",
      locationPath: "/application/existing-application",
    },
    uploadDocument: {
      path: "upload-document",
      locationPath: "/application/upload-document",
    },
    applyNow: {
      path: "apply-now",
      locationPath: "/application/apply-now",
    },
    viewAllApplications: {
      path: "view-all-applications",
      locationPath: "/view-all-applications",
    },
    mandatoryDocuments: {
      path: "mandatory-documents",
      locationPath: "/application/mandatory-documents",
    },
    bulkDocuments: {
      path: "bulk-documents",
      locationPath: "/application/bulk-documents",
    },
    
  },
  Dashboard: {
    index: "/dashboard",
    flexiTermLoan: {
      path: "flexi-term-loan",
      locationPath: "/dashboard",
      accountSummary: {
        path: "account-summary",
        locationPath: "/dashboard/account-summary",
      },
    },
    termLoanPage: {
      path: "term-loan",
      locationPath: "/dashboard/term-loan",
      requestForDisbursement: {
        path: "request-for-disbursement",
        locationPath: "/dashboard/term-loan/request-for-disbursement",
      },
      viewAllLoans: {
        path: "view-all-loans",
        locationPath: "/dashboard/term-loan/view-all-loans",
      },
      disburseMentData: {
        path: "disbursement",
        locationPath: "/dashboard/term-loan/disbursement",
      },
    },
  },
  // profile
  Profile: {
    index: "/profile",
    changePassword: {
      path: "change-password",
      locationPath: "/profile/change-password",
    },
  },
  Maintenance: {
    index: "/maintenance-page",
  },
  ContactUs: {
    index: "/contact-us",
    raiseRequest: {
      path: "raise-request",
      locationPath: "/contact-us/raise-request",
    },
    viewTickets: {
      path: "view-tickets",
      locationPath: "/contact-us/view-tickets",
    },
    ticketDetails: {
      path: "tickets/:ticketNumber",
      locationPath: "/contact-us/tickets",
    },
    lodgeComplaint: {
      path: "lodge-complaint",
      locationPath: "/contact-us/lodge-complaint",
    },
  },
  // notifications
  Notifications: {
    index: "/notifications",
  },
  DocumentCollection: {
    index: "/",
    otp: {
      path: "document-collection-verify-link-otp",
    },
    uploadDocs: {
      path: "upload-documents/:applicationId",
    },
  },
  // sidNavBarMenuOptions
  SidNavBarMenuOptions: [
    {
      path: "/dashboard",
      label: "Dashboard",
      icon: DashboardIcon,
    },
    {
      path: "",
      label: "Fund Request",
      icon: DisbursementIcon,
    },
    {
      path: "",
      label: "Payment",
      icon: PaymentIcon,
    },
    {
      path: "",
      label: "Documents",
      icon: DocumentIcon,
    },
    {
      path: "",
      label: "History",
      icon: HistoryIcon,
    },
  ],
  SideNavBarMenuFlexiOptions: [
    {
      path: "/dashboard",
      label: "Loans",
      icon: DashboardIcon,
    },
    {
      path: "",
      label: "Withdraw",
      icon: DisbursementIcon,
    },
    {
      path: "",
      label: "Payment",
      icon: HistoryIcon,
    },
    {
      path: "",
      label: "Documents",
      icon: DocumentIcon,
    },
  ],
  // quickLinks
  QuickLinks: {
    path: "",
    label: "QuickLinks",
    icon: HelpOutlineIcon,
    QuickLinks: [
      { path: "https://www.avanse.com/disclaimer", label: "Disclaimer" },
      {
        path: "https://www.avanse.com/privacy-policy",
        label: "Privacy Policy",
      },
      {
        path: "https://www.avanse.com/terms-conditions",
        label: "Terms & Conditions",
      },
      {
        path: "https://www.avanse.com/grievance-redressal-mechanism#ombudsman-scheme",
        label: "Ombudsman Scheme",
      },
      {
        path: "/contact-us/lodge-complaint",
        label: "Lodge a Complaint",
        isInternal: true,
      },
    ],
  },
};
